var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgChatUnderline = function SvgChatUnderline(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4305 18.3368V20.1701H4.59716V18.3368H17.4305ZM14.6805 12.1172C14.6503 12.7222 14.4707 13.3103 14.1578 13.8289C13.8448 14.3475 13.4082 14.7806 12.8871 15.0893C12.3659 15.398 11.7764 15.5727 11.1711 15.598C10.5659 15.6232 9.96389 15.4981 9.41883 15.2339C8.79059 14.9621 8.25779 14.5089 7.8887 13.9324C7.51962 13.3559 7.33105 12.6824 7.34717 11.998V4.59138H5.51383V12.1172C5.54484 12.9802 5.77861 13.8237 6.19621 14.5795C6.61382 15.3353 7.20352 15.9822 7.91758 16.4678C8.63164 16.9533 9.45 17.2639 10.3064 17.3745C11.1628 17.485 12.0332 17.3923 12.8472 17.1039C13.9299 16.743 14.8692 16.0462 15.5286 15.1147C16.1881 14.1833 16.5332 13.0658 16.5138 11.9247V4.59138H14.6805V12.1172ZM14.6805 4.58679H16.5138H14.6805ZM7.34717 4.58679H5.51383H7.34717Z",
    fill: "#8F97B9"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChatUnderline, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chat_underline.ffc3ca48.svg";
export { ForwardRef as ReactComponent };